






















import Vue from "vue";

// リリース日からリリースの通知バーを表示する期間（date）
const DISPLAY_PERIOD = 7;

export default Vue.extend({
  methods: {
    isBarDisplay(): boolean {
      return this.isReleaseNotificationDisplay() || this.$t("releaseNote.bugNotification") !== "";
    },
    isReleaseNotificationDisplay(): boolean {
      let newestReleaseDate = new Date(
        (this as any).$t("releaseNote.contents[0].releaseYear"),
        (this as any).$t("releaseNote.contents[0].releaseMonth") - 1,
        (this as any).$t("releaseNote.contents[0].releaseDay")
      );
      newestReleaseDate.setDate(newestReleaseDate.getDate() + DISPLAY_PERIOD);
      let displayLimitDate = newestReleaseDate;
      let today = new Date();
      let todayYear = today.getFullYear();
      let todayMonth = today.getMonth();
      let todayDate = today.getDate();
      today = new Date(todayYear, todayMonth, todayDate);
      return today <= displayLimitDate;
    },
  },
});
